import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { projectListData } from "../helpers/projectListData";
import { motion } from "framer-motion";
import {
  gridContainterVariants,
  gridCubeVariants,
} from "../utilities/customHooks";

function ProjectDetail() {
  const [loadedImages, setLoadedImages] = useState([]);
  const navigate = useNavigate();
  const { id } = useParams();
  const project = projectListData[id];

  const currentId = Number(id);
  const totalProjects = Array.isArray(projectListData)
    ? projectListData.length
    : Object.keys(projectListData).length;
  const nextProjectId = currentId < totalProjects - 1 ? currentId + 1 : 0;
  const prevProjectId = currentId > 0 ? currentId - 1 : totalProjects - 1;

  const {
    tags,
    projectDetail: {
      intro: { title, content, bigAttachment },
    },
  } = project;
  const attachments = Array.isArray(bigAttachment)
    ? bigAttachment
    : [bigAttachment];

  useEffect(() => {
    setLoadedImages([]);
  }, [bigAttachment]);

  function replaceWithBr() {
    return content.replace(/\n/g, "<br />");
  }

  return (
    <>
      <motion.div
        className="projDetail"
        variants={gridContainterVariants}
        initial="hidden"
        animate="show"
      >
        <a className="goBack" onClick={() => navigate("/")}></a>
        <h2>{project.name}</h2>
        <div className="projPagination">
          <a
            className="goPrev"
            onClick={() => navigate(`/project/${prevProjectId}`)}
          ></a>
          <a
            className="goNext"
            onClick={() => navigate(`/project/${nextProjectId}`)}
          ></a>
        </div>
        <motion.div variants={gridCubeVariants} className="contentSection">
          <h4>{title}</h4>
          <br />
          <p dangerouslySetInnerHTML={{ __html: replaceWithBr() }}></p>
          <div className="tags">
            {tags.map((tag, index) => {
              return <p key={index}>{tag}</p>;
            })}
          </div>
          {project.name == "SAND" ? (
            <object data={attachments[0]} type="application/pdf"></object>
          ) : (
            attachments.map((attachment, index) => {
              const imageLoaded = loadedImages.includes(index);

              return (
                <div className="projectImageWrapper" key={index}>
                  {!imageLoaded && (
                    <div
                      className="imageLoader"
                      role="status"
                      aria-label="Loading image"
                    ></div>
                  )}
                  <img
                    src={attachment}
                    alt={`${project.name} project${
                      attachments.length > 1 ? ` ${index + 1}` : ""
                    }`}
                    onLoad={() =>
                      setLoadedImages((current) => [...current, index])
                    }
                    className={imageLoaded ? "isLoaded" : "isLoading"}
                  />
                </div>
              );
            })
          )}
        </motion.div>
      </motion.div>
    </>
  );
}

export default ProjectDetail;
